import { useEffect, useState } from 'react';
import { s } from './List.styles';
import Select, { SingleValue } from 'react-select';
import { ReportFormatNumber } from '../../../func/Function';
import { ListDataProps, SortOption, SortOptions } from './data';
import Pagination from '../pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import InterestSerivce from '../../../service/Interest';
import { FilterType } from '../../search/FilterData';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';
import ScheduledCard from '../../scheduled/components/ScheduledCard';
import Loading from '../../../func/components/loading/LoadingCircle';

interface ListCardProps {
  data: ListDataProps[];
  totalCount?: number;
  sort?: SortOption;
  setSort?: (sort: SortOption) => void;
  offset?: number;
  setOffset?: (offset: number) => void;
  filters?: FilterType;
  bondFilters?: any;
  limit?: number;
  loading?: boolean;
  page: string;
  setSelectedIdx: (idx: number) => void;
  setShowLikeModal?: (value: boolean) => void;
  setMode?: (value: string) => void;
  setSelectedItem: (value: {
    iidx: number;
    group: string;
    group_idx: number;
    level: number;
    memo: string;
  }) => void;
  activeItem: number | null;
  setActiveItem: (value: number | null) => void;
  getList?: (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters?: any,
  ) => void;
  isPossible?: boolean;
  compact?: boolean;
}
const List = ({
  data,
  totalCount = 0,
  sort,
  setSort,
  offset = 0,
  setOffset,
  filters,
  bondFilters,
  limit = 10,
  loading = false,
  page,
  setSelectedIdx,
  setShowLikeModal,
  setMode,
  setSelectedItem,
  activeItem,
  setActiveItem,
  getList,
  isPossible = true,
  compact = false,
}: ListCardProps) => {
  filters = filters || bondFilters;
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());
  const [expandedMemos, setExpandedMemos] = useState<Set<number>>(new Set());
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  const navigate = useNavigate();

  const toggleMemoExpand = (index: number) => {
    setExpandedMemos((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (totalCount) {
      setTotalPages(Math.ceil(totalCount / limit));
    }
  }, [totalCount]);

  useEffect(() => {
    if (!compact && totalCount) {
      setTotalPages(Math.ceil(totalCount / limit));
    }
  }, [totalCount, limit, compact]);

  useEffect(() => {
    if (compact) return;
    if (loading && currentPage > 1) {
      const listTop = document.getElementById('list-top');
      if (listTop) {
        const y = listTop.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }, [loading]);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };
  const toggleExpand = (index: number) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const renderTags = (tags: string[], index: number) => {
    const isExpanded = expandedRows.has(index);
    const maxVisibleTags = 2;

    if (!tags || tags.length === 0) return null;

    if (isExpanded) {
      return (
        <>
          {tags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}

          <s.TagText
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(index);
            }}
          >
            <span>접기</span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt=""
              style={{ width: '16px', transform: 'rotate(180deg)' }}
            />
          </s.TagText>
        </>
      );
    } else {
      const visibleTags = tags.slice(0, maxVisibleTags);
      const remainingCount = tags.length - maxVisibleTags;

      return (
        <>
          {visibleTags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}
          {remainingCount > 0 && (
            <s.TagText
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(index);
              }}
            >
              +{remainingCount}개
            </s.TagText>
          )}
        </>
      );
    }
  };

  const handlePageChange = (page: number) => {
    if (compact) return;
    if (!isPossible) {
      modalDispatch({ type: 'USER_ALERT', payload: 'free' });
      return;
    }
    setCurrentPage(page);
    setOffset && setOffset((page - 1) * limit);
  };

  const NoDataText = () => {
    if (page === 'search') {
      return '검색 결과가 없습니다';
    }
    if (page === 'interest') {
      return '관심물건이 없습니다.';
    }
    if (page === 'recent') {
      return '최근 열람 물건이 없습니다.';
    }
  };

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      setActiveItem(null);
      alert('관심물건에서 삭제되었습니다.');
      if (getList && filters) {
        getList(
          offset || 0,
          sort || { value: 'DA', label: '매각기일 빠른순' },
          filters || {},
        );
      } else {
        getList &&
          getList(
            offset || 0,
            sort || { value: 'DA', label: '매각기일 빠른순' },
          );
      }
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  useEffect(() => {
    if (offset === 0 || offset === undefined) {
      setCurrentPage(1);
    }
  }, [offset]);
  const { modalDispatch } = useModal();
  return (
    <div id="list-top">
      {!isLogin() ? (
        <div
          style={{
            textAlign: 'center',
            fontSize: '13px',
            color: '#616161',
            fontWeight: '500',
            padding: '16px',
            paddingBottom: '60px',
          }}
        >
          로그인 후 이용이 가능합니다.
        </div>
      ) : (
        <s.Container>
          {!compact && (
            <s.ListTop>
              <div>총 {Number(totalCount).toLocaleString()}개</div>
              <Select
                options={SortOptions}
                styles={{
                  ...customStyles,
                  menuPortal: (b: any) => ({ ...b, zIndex: 9999 }),
                }}
                placeholder="선택"
                value={sort}
                onChange={(selected) => {
                  if (setSort && selected) setSort(selected);
                }}
              />
            </s.ListTop>
          )}
          {/* <s.ListTop>
            <div>총 {Number(totalCount).toLocaleString()}개</div>
            <Select<SortOption>
              options={SortOptions}
              styles={{
                ...customStyles,
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              placeholder="선택"
              value={sort}
              onChange={(selectedOption: SingleValue<SortOption>) => {
                if (selectedOption) {
                  setSort(selectedOption);
                }
              }}
            />
          </s.ListTop> */}
          {/* <Loading /> */}
          {loading && <Loading />}
          {!loading && Array.isArray(data) && data.length > 0 && (
            <s.ListBox>
              <s.List>
                {data.map((item, index) =>
                  item.type === 'e' ? (
                    <ScheduledCard
                      item={{
                        addr: item.address,
                        belong: item.courtcode,
                        billing_price: item.a_price,
                        case_nm: item.courtname,
                        caseno: item.caseno,
                        court: item.courtname,
                        creditor: '',
                        debtor: '',
                        dec_date: JSON.parse(item.saledate).f1,
                        div_date: JSON.parse(item.saledate).f2,
                        owner: '',
                        pnu: '',
                        reg_date: JSON.parse(item.saledate).f3,
                        road_addr: item.address,
                        t_idx: item.iidx.toString(),
                        count: Number(item.count),
                      }}
                    />
                  ) : (
                    <ItemCard
                      index={index}
                      item={item}
                      page={page}
                      setSelectedIdx={setSelectedIdx}
                      setShowLikeModal={setShowLikeModal}
                      handleDisLikeItem={handleDisLikeItem}
                      renderTags={renderTags}
                      setActiveItem={setActiveItem}
                      activeItem={activeItem}
                      expandedMemos={expandedMemos}
                      toggleMemoExpand={toggleMemoExpand}
                      setSelectedItem={setSelectedItem}
                      setMode={setMode}
                    />
                  ),
                )}
              </s.List>
              {!compact && totalPages > 1 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              )}
            </s.ListBox>
          )}
          {!loading && Array.isArray(data) && data.length === 0 && (
            <s.Nodata $isCompact={compact}>{NoDataText()}</s.Nodata>
          )}
        </s.Container>
      )}
    </div>
  );
};

export default List;

const ItemCard = ({
  index,
  item,
  page,
  setSelectedIdx,
  setShowLikeModal,
  handleDisLikeItem,
  renderTags,
  setActiveItem,
  activeItem,
  expandedMemos,
  toggleMemoExpand,
  setSelectedItem,
  setMode,
}: {
  index: number;
  item: ListDataProps;
  page: string;
  setSelectedIdx: (idx: number) => void;
  setShowLikeModal: ((value: boolean) => void) | undefined;
  handleDisLikeItem: (iidx: number) => void;
  renderTags: (tags: string[], index: number) => React.ReactNode;
  setActiveItem: (value: number | null) => void;
  activeItem: number | null;
  expandedMemos: Set<number>;
  toggleMemoExpand: (index: number) => void;
  setSelectedItem: (value: {
    iidx: number;
    group: string;
    group_idx: number;
    level: number;
    memo: string;
  }) => void;
  setMode: ((value: string) => void) | undefined;
}) => {
  const startDT = item.start_dt
    ? new Date(item.start_dt.replace(' ', 'T'))
    : null;
  const isFuture = startDT ? new Date() < startDT : false;

  // p_status가 '예정'이거나 시작일이 미래면 '예정'으로 표시
  const displayPStatus =
    item.p_status === '예정' || isFuture ? '예정' : item.p_status;
  return (
    <s.ListCard
      isActive={false}
      key={index}
      onClick={async () => {
        // setActiveIidx(item.b_idx);
        // setLatLng({ lat: item.lat, lng: item.lng });
        // setSelectedItemInfo({
        //   iidx: item.b_idx,
        //   b_idx: item.b_idx,
        //   type: 'b',
        //   lat: item.lat,
        //   lng: item.lng,
        // });
        // setRoadViewLatLng({ lat: item.lat, lng: item.lng });
        if (item.type === 'a') {
          window.open(
            `/auction/detail/${item.iidx2}` +
              (window.location.pathname.includes('/search/npl')
                ? '?type=b'
                : ''),
          );
        } else {
          window.open(`/pauction/detail/${item.iidx2}`);
        }
        // if (await UserService.userGrade()) {
        // } else {
        //   modalDispatch({ type: 'USER_ALERT', payload: 'free' });
        // }
      }}
    >
      <s.ItemInfoBox>
        <div>
          {item.caseno}
          {item.unitno} | {item.courtname} | {item.category}
        </div>
        <s.ItemTypeChip
          style={{
            backgroundColor: item.type === 'a' ? '#FFDBD6' : '#DEEDFF',
            color: item.type === 'a' ? '#D84836' : '#0C64CE',
          }}
        >
          {item.type === 'a' ? '경매' : '공매'}
        </s.ItemTypeChip>
      </s.ItemInfoBox>
      <s.ListCardContentBox>
        <s.CardTextBox>
          <s.CardTitle>
            {item.address ? <>{item.address}</> : <>업데이트 준비중</>}
          </s.CardTitle>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            <s.Status>
              {item?.type === 'a' ? '매각기일 ' : '입찰기간'}
              <strong>
                {/* 공매일 때 */}
                {/* {item?.type === 'p'
                  ? item.saledate || '업데이트 준비중'
                  :
                    item?.bid?.trim() === '매각'
                    ? item.start_dt
                      ? item.start_dt.split(/[ T]/)[0].replaceAll('-', '.')
                      : '업데이트 준비중'
                    : item.start_dt && item.end_dt
                      ? `${item.start_dt.split(/[ T]/)[0].replaceAll('-', '.')}~${item.end_dt
                          .split(/[ T]/)[0]
                          .replaceAll('-', '.')}`
                      : '업데이트 준비중'} */}
                {item.type === 'p' && item.p_status?.trim() === '매각' ? (
                  // 공매 + 매각: 시작일만 단일 표시
                  <>{item.start_dt ? item.start_dt.split(/[ T]/)[0] : '-'}</>
                ) : item.start_dt || item.end_dt ? (
                  // 기본: 입찰기간
                  <>
                    {item.start_dt ? item.start_dt.split(/[ T]/)[0] : '-'} ~
                    <br />
                    {item.end_dt ? item.end_dt.split(/[ T]/)[0] : '-'}
                  </>
                ) : (
                  // 기간정보가 없으면 saledate(매각기일) fallback
                  <>{item.saledate ? item.saledate.split(/[ T]/)[0] : '-'}</>
                )}
              </strong>
            </s.Status>
            <s.CardPrice>
              감정가 <strong>{Number(item.a_price).toLocaleString()}원</strong>
            </s.CardPrice>
            {item.bidprice ? (
              <s.BidPrice>
                낙찰가{' '}
                <strong>{Number(item.bidprice).toLocaleString()}원</strong>
              </s.BidPrice>
            ) : (
              <s.BidPrice>
                최저가{' '}
                <strong>
                  {Number(item.minPrice || item.minPrice).toLocaleString()}원
                </strong>
              </s.BidPrice>
            )}
            {item.bidprice && item.a_price && item.a_per !== null && (
              <s.BidPrice>
                ({`낙찰가율 ${item.a_per > 0 ? `+${item.a_per}` : item.a_per}%`}
                )
              </s.BidPrice>
            )}
          </div>
        </s.CardTextBox>
        <s.CardImgBox>
          <div style={{ position: 'relative' }}>
            {item.bid.trim() === '매각' ? (
              <img
                src="/assets/images/sale-complete.png"
                alt=""
                style={{
                  height: 80,
                  width: 80,
                  borderRadius: 8,
                }}
              />
            ) : (
              <img
                src={
                  item.img === null ? '/assets/images/no-image.svg' : item.img
                }
                alt=""
                style={{
                  height: 80,
                  width: 80,
                  borderRadius: 8,
                }}
              />
            )}
            <img
              src={`/assets/images/icon/${item.is_like ? 'like-on' : 'like-off-outline'}.svg`}
              alt=""
              style={{
                position: 'absolute',
                top: 4,
                right: 4,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (page === 'mypattern') {
                  return;
                }
                if (!item.is_like) {
                  setSelectedIdx(item.iidx2);
                  setShowLikeModal && setShowLikeModal(true);
                } else {
                  handleDisLikeItem(item.iidx2);
                }
              }}
            />
          </div>

          <s.ViewCount>
            <img src="/assets/images/icon/view-gray.svg" alt="" />
            <span>{item.count ?? 0}회</span>
            <span>({item.valid_view_count ?? 0}회)</span>
          </s.ViewCount>
        </s.CardImgBox>
      </s.ListCardContentBox>
      <s.HashTagWrapper>
        {item.bidno > 0 && item.bidno !== null && (
          <s.BidTag>{'유찰' + item.bidno + '회'}</s.BidTag>
        )}
        {displayPStatus !== '-' &&
          (displayPStatus === '준비중' || displayPStatus === '예정' ? (
            <s.BidTag03>입찰 {displayPStatus}</s.BidTag03>
          ) : (
            <s.BidTag02>입찰 {displayPStatus}</s.BidTag02>
          ))}
        {item.bid === '매각' && <s.BidTag>낙찰</s.BidTag>}
        {item.bid === '신건' && (
          <s.BidTag
            style={{
              color: '#1F9E54',
              backgroundColor: '#E6F4F0',
            }}
          >
            신건
          </s.BidTag>
        )}
        {renderTags(
          [
            ...(item.viewgray2
              ? item.viewgray2.split(' / ').filter((el) => el !== '')
              : []),
          ],
          index,
        )}
      </s.HashTagWrapper>
      {page === 'interest' && (
        <s.InterestBox onClick={(e) => e.stopPropagation()}>
          <s.Rating>
            <s.RatingText>
              {Array.from({ length: item.level }).map((_, i) => (
                <img
                  key={i}
                  src="/assets/images/icon/star-blue.svg"
                  alt=""
                  style={{ width: 14, height: 14 }}
                />
              ))}
              <span>{item.group}</span>
            </s.RatingText>
            <img
              src="/assets/images/icon/meatball.svg"
              alt=""
              onClick={(e) => {
                e.stopPropagation();
                setActiveItem(activeItem === item.iidx2 ? null : item.iidx2);
              }}
              style={{ cursor: 'pointer' }}
            />
          </s.Rating>
          <s.MemoBox>
            <div style={{ maxWidth: 350 }}>
              <span
                style={{
                  width: '100%',
                  whiteSpace: expandedMemos.has(item.iidx2)
                    ? 'normal'
                    : 'nowrap',
                  overflow: expandedMemos.has(item.iidx2) ? 'unset' : 'hidden',
                  textOverflow: expandedMemos.has(item.iidx2)
                    ? 'unset'
                    : 'ellipsis',
                }}
              >
                {item.memo}
                {expandedMemos.has(item.iidx2) && (
                  <s.MoreText
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleMemoExpand(item.iidx2);
                    }}
                  >
                    접기
                  </s.MoreText>
                )}
              </span>
            </div>
            {!expandedMemos.has(item.iidx2) &&
              item.memo &&
              item.memo.length > 34 && (
                <s.MoreText
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleMemoExpand(item.iidx2);
                  }}
                >
                  더보기
                </s.MoreText>
              )}
          </s.MemoBox>
          {activeItem === item.iidx2 && (
            <s.EditBox>
              <s.EditBoxRow
                style={{
                  borderBottom: '1px solid #E1E2E4',
                }}
                onClick={() => {
                  setSelectedIdx(item.iidx2);
                  setSelectedItem({
                    iidx: item.iidx2,
                    group: item.group ?? '',
                    group_idx: item.group_idx ?? 0,
                    level: item.level,
                    memo: item.memo ?? '',
                  });
                  setMode && setMode('edit');
                  setShowLikeModal && setShowLikeModal(true);
                }}
              >
                <span>수정하기</span>
                <img src="/assets/images/icon/write.svg" alt="" />
              </s.EditBoxRow>
              <s.EditBoxRow
                onClick={() => {
                  handleDisLikeItem(item.iidx2);
                }}
              >
                <span>삭제하기</span>
                <img src="/assets/images/icon/trashcan.svg" alt="" />
              </s.EditBoxRow>
            </s.EditBox>
          )}
        </s.InterestBox>
      )}
    </s.ListCard>
  );
};
